export var ChatConstants;
(function (ChatConstants) {
    ChatConstants[ChatConstants["MinimumTextCharacters"] = 1] = "MinimumTextCharacters";
    ChatConstants[ChatConstants["MaximumTextCharacters"] = 500] = "MaximumTextCharacters";
})(ChatConstants || (ChatConstants = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/ChatConstants.ts
// module id = 824
// module chunks = 3